// v0.6 — single source of truth for building a /calculate (or
// /calculate/async) request body.
//
// Extracted from two independently hand-maintained call sites --
// CalculatePanel.jsx's `run()` and WorkflowContext.jsx's `runCalc()` --
// which each spelled out the same field list separately. That pattern
// already caused one real, shipped bug (v0.5.9y: monthly_fx_rates was
// added to one call site and not the other, silently resetting national-
// return FX rates on every recalc through the missed path). Found on
// self-review while auditing this exact area for the FX-flow redesign:
// runCalc() additionally never sent `client_id` at all, which the backend
// silently treats as "use whichever client is marked default" instead of
// erroring -- so a recalculation triggered by resolving a flagged review
// item (VAT number amend, refund-channel resolve, service-country
// resolve) on a NON-default client would rehydrate settings_cache
// (establishment, filing model, Art 59c threshold state) from the wrong
// client. Fixed here by having both call sites go through this one
// builder instead of drifting independently again.
export const buildCalcPayload = ({
  registrations,
  runIds,
  periodStart,
  periodEnd,
  countryFilter,
  periodFxRates,
  monthlyFxRates,
  clientId,
}) => {
  const regs = registrations || [];
  // v0.6.6 — regime and seller_country used to be derived independently
  // from the same array (regime: "does it contain GB anywhere",
  // seller_country: "whatever is at index 0"), and `registrations` has no
  // ordering guarantee — it's append order from Settings, not sorted. A
  // client registered in an EU country before GB (regs = ["DE", "GB"])
  // produced regime=UK_VAT paired with seller_country="DE": a UK-regime
  // calc attributed to a German seller. routes_supersede.py's own rerun
  // path already hardcodes the correct pairing (seller_country="GB" iff
  // regime is UK_VAT) — mirrored here so a fresh calc agrees with a
  // superseded rerun of the same client.
  const isUkVat = regs.includes("GB");
  return {
    regime: isUkVat ? "UK_VAT" : "EU_OSS",
    run_ids: runIds,
    period_start: periodStart,
    period_end: periodEnd,
    seller_country: isUkVat ? "GB" : (regs[0] || "GB"),
    country_filter: countryFilter,
    period_fx_rates: periodFxRates,
    monthly_fx_rates: monthlyFxRates,
    client_id: clientId || undefined,
  };
};
